/**
 * Employees module theme — aliases app brand (Patient indigo SoT).
 *
 * Prefer importing from here in Employees UI so the module stays swappable
 * without reaching into Patients/. Color changes still flow from patientTheme.
 */
import { BRAND_THEME, BRAND_THEME_HEX } from "../../ui/brandTheme";

export { BRAND_THEME as EMPLOYEE_THEME, BRAND_THEME_HEX as EMPLOYEE_THEME_HEX };

/** Shared position chip — one brand tone (not per-role rainbow). */
export const EMPLOYEE_ROLE_CHIP =
  "bg-indigo-50 text-indigo-700 border border-indigo-100";

export const EMPLOYEE_BTN = {
  primary: `inline-flex items-center justify-center gap-2 h-10 px-5 text-sm font-semibold rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${BRAND_THEME.button.primary}`,
  outline: `inline-flex items-center justify-center gap-2 h-10 px-5 text-sm font-medium rounded-lg border transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${BRAND_THEME.button.outline}`,
  cancel:
    "inline-flex items-center justify-center gap-2 h-10 px-5 text-sm font-medium rounded-lg border border-slate-300 bg-white text-slate-700 hover:bg-slate-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
  danger:
    "inline-flex items-center justify-center gap-2 h-10 px-5 text-sm font-semibold rounded-lg border border-red-200 bg-red-50 text-red-700 hover:bg-red-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
  close:
    "inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-white border border-indigo-200 text-slate-500 shadow-sm hover:bg-indigo-50 hover:text-indigo-700 transition-colors",
};

/**
 * Employee / profile form shell — same numbered-section pattern for
 * Add Employee, Update Employee and My Profile.
 */
export const EMPLOYEE_FORM = {
  page: "p-6 min-h-screen bg-slate-50",
  shell: "max-w-5xl mx-auto relative",
  /**
   * Close sits outside the card, clear of the header row, so the header can
   * span the full content width and its actions stay flush with the fields.
   */
  closeFloat: "absolute -top-3 -right-3 z-30",
  card: `bg-white rounded-xl border shadow-sm p-6 sm:p-8 ${BRAND_THEME.section.wrap}`,
  title: "text-2xl font-bold text-slate-900",
  header: "mb-6 flex flex-wrap items-center justify-between gap-x-4 gap-y-3",
  /**
   * Header actions (page buttons + close). `ml-auto` keeps them flush right
   * even after the row wraps, so they line up with the form fields below.
   */
  headerActions: "flex flex-wrap items-center gap-2 ml-auto shrink-0",
  sectionHead:
    "flex items-center gap-2 mb-5 border-b border-indigo-100 pb-2",
  /** Numbered step bubble — brand tone, readable text. */
  step: `w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold shrink-0 ${BRAND_THEME.section.badge}`,
  sectionTitle: "text-slate-900 font-semibold text-lg",
  footer:
    "flex flex-wrap items-center justify-between gap-x-4 gap-y-3 pt-6 mt-8 border-t border-indigo-100",
  footerLeft: "flex flex-wrap items-center gap-2",
  /** Cancel + submit stay flush right on every breakpoint. */
  footerRight: "flex flex-wrap items-center gap-2 ml-auto",
  errorBanner:
    "bg-red-50 border-l-4 border-red-400 p-4 rounded-r-lg mb-6 flex items-start gap-3",
};
